<template>
  <v-row>
    <v-col>
      <v-card>
        <general-error v-if="!!generalError" />
        <v-card-text>
          <trade-result-divisible-volume
              v-if="isDivisibleVolume"
              :orders="orders"
              :is-fix-price="isFixPremium"
              readonly
              :loading="isLoading" />
          <trade-result-full-volume
              v-else
              :orders="orders"
              :is-fix-price="isFixPremium"
              readonly
              :loading="isLoading" />
          <v-row>
            <v-col class="text-left">
              <text-view
                  :display="tradeResult"
                  :label="$t('Итог торгов')" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="canViewResult">
          <v-btn
              v-if="canUploadOfferRegistry && !isLoading"
              id="uploadReestrBtn"
              v-test="{ btn: 'reestr' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="attachLotOffersRegistry">
            {{ $t('Прикрепить реестр предложений') }}
          </v-btn>
          <v-btn
              v-if="canCreateNoOrderResult && !isLoading"
              id="createNoOrdersBtn"
              key="createNoOrders"
              v-test="{ btn: 'createNoOrders' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="openConfirmDialog">
            {{ $t('Подвести итоги (нет ценовых предложений)') }}
          </v-btn>
          <v-btn
              v-if="canEditResult && !isLoading"
              id="updateBtn"
              key="update"
              v-test="{ btn: 'update' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="goToWinnerSelection">
            {{ $t('Изменить итоги') }}
          </v-btn>
          <v-btn
              v-if="canCreateResult && !isLoading"
              id="createBtn"
              key="create"
              v-test="{ btn: 'create' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="goToWinnerSelection">
            {{ $t('Подвести итоги') }}
          </v-btn>
          <confirm-dialog
              v-if="confirmDialog.show"
              :dialog-prop="confirmDialog"
              @close="closeDialog('confirmDialog')" />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
  .orders::v-deep td:nth-child(3) {
   word-break: break-all;
   max-width: 450px;
  }
  .orders::v-deep td:nth-child(1) {
    min-width: 200px;
  }
  .premiums::v-deep td:nth-child(1) {
    word-break: break-all;
    max-width: 550px;
  }
  .premiums::v-deep td:nth-child(2) {
    min-width: 150px;
  }
</style>

<script>

  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import { TRADE_RESULT_TYPE_FULL_VOLUME_ENUM } from '@/constants/enums'
  import { LOT_STATUSES, TRADE_RESULT_TYPES, DOCUMENT_TYPES, LOT_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { LOT_DOCUMENTATION, LOT_WINNERS_MANAGEMENT, LOT_DOCUMENT_GENERATOR } from '@/constants/store.js'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'
  import TradeResultFullVolume from '@/components/reused/orders/TradeResultFullVolume.vue'
  import TradeResultDivisibleVolume from '@/components/reused/orders/TradeResultDivisibleVolume.vue'

  export default {
    components: {
      GeneralError,
      ConfirmDialog,
      TextView,
      TradeResultFullVolume,
      TradeResultDivisibleVolume
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      lot: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        LOT_STATUSES,
        isLoading: false,
        itemsPerPage: 10,
        nestedItemsPerPage: -1,
        confirmDialog: {
          show: false,
          text: null,
          callback: null,
          warning: true
        }
      }
    },
    computed: {
      ...mapState(LOT_DOCUMENTATION.NAMESPACE, {
        tradeProcessDocumentation: state => (state[LOT_DOCUMENTATION.STATE.TRADE_PROCESS_DOCUMENTATION] || [])
      }),
      ...mapState(LOT_WINNERS_MANAGEMENT.NAMESPACE, {
        winnersInfo: state => (state[LOT_WINNERS_MANAGEMENT.STATE.WINNER_SELECTION_LIST] || {})
      }),
      isFixPremium () {
        return true // this.lot.premiumType === PREMIUM_TYPES.FIX
      },
      isDivisibleVolume () {
        return this.lot.lotType === LOT_TYPES.REQUEST_OFFERS_DIVISIBLE_VOLUME
      },
      canViewResult () {
        return (this.isAdmin || this.isLotOwner(this.lot)) &&
          !!this.lot.lotStatus
      },
      canCreateNoOrderResult () {
        return !this.hasResult &&
          !this.hasOrder &&
          this.canViewResult &&
          this.lot.lotStatus === LOT_STATUSES.REGISTERED &&
          this.isAdmin
      },
      canCreateResult () {
        return this.hasOrder &&
          !this.hasResult &&
          this.canViewResult &&
          this.lot.lotStatus === LOT_STATUSES.REGISTERED
      },
      canEditResult () {
        return this.hasOrder &&
          this.hasResult &&
          this.isAdmin &&
          this.lot.lotStatus === LOT_STATUSES.FINISHED
      },
      canUploadOfferRegistry () {
        return false
        // return !this.hasUploadOfferRegistry &&
        //   (this.isAdmin || (this.isLotOwner(this.lot) && !this.hasResult)) &&
        //   !this.isLoading // admin - после подведения итогов, организатор - до.
      },
      headers1 () {
        let headers = [
          { text: this.$t('№ Сессии'), sortable: false, value: 'sessionNumber' },
          { text: this.$t('Организация'), sortable: false, value: 'organizationName' },
          { text: this.$t('Пользователь'), sortable: false, value: 'userName' },
          { text: this.$t('Время выставления'), sortable: false, value: 'orderDate' },
          { text: this.$t('Победитель'), sortable: false, value: 'isWinner' },
          { text: '', value: 'data-table-expand' }
        ]
        if (!this.isAdmin) {
          headers = headers.filter(h => h.value !== 'userName' && h.value !== 'sessionNumber')
        }
        return headers
      },
      headers2 () {
        let headers = [
          { text: this.$t('Предмет договора'), sortable: false, value: 'positionDescription' },
          { text: this.$t(this.isFixPremium ? 'Цена 1 (одной) углеродной единицы (с учетом НДС)' : 'Значение дифференциала'), sortable: false, value: 'premium' },
          { text: this.$t('Общая стоимость торговой процедуры, {0}', [this.lot.currency]), sortable: false, value: 'orderCost' }
        ]
        if (!this.isFixPremium) {
          headers = headers.filter(h => h.value !== 'orderCost')
        }
        return headers
      },
      orders () {
        const orders = this.winnersInfo.orders || []
        return orders
      },
      hasResult () {
        const result = this.winnersInfo.tradeResultType
        return !!result && result !== TRADE_RESULT_TYPES.UNSET
      },
      hasOrder () {
        return this.orders.length > 0
      },
      tradeResult () {
        const result = this.winnersInfo.tradeResultType
        return this.$t(result
          ? TRADE_RESULT_TYPE_FULL_VOLUME_ENUM[result]
          : TRADE_RESULT_TYPE_FULL_VOLUME_ENUM[TRADE_RESULT_TYPES.UNSET])
      },
      hasWinnerSelected () {
        const result = this.winnersInfo.tradeResultType
        return !!result && result === TRADE_RESULT_TYPES.WINNER_SELECTED
      },
      hasUploadOfferRegistry () {
        const mainDocTypesList = [
          DOCUMENT_TYPES.REGISTRY
        ]
        return this.hasUploadDocuments(mainDocTypesList)
      },
      hasUploadDocuments () {
        return (mainDocTypesList) => {
          const lotDocumentation = this.tradeProcessDocumentation
          return lotDocumentation.some(d => mainDocTypesList.includes(d.documentType))
        }
      }
    },
    watch: {
      lot: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal.lotId) {
            this.initialize()
          }
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_DOCUMENTATION.NAMESPACE, {
        getTradeProcessDocumentationAction: LOT_DOCUMENTATION.ACTIONS.GET_TRADE_PROCESS_DOCUMENTATION,
        clearTradeProcessDocumentationAction: LOT_DOCUMENTATION.ACTIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION
      }),
      ...mapActions(LOT_WINNERS_MANAGEMENT.NAMESPACE, {
        getWinnerSelectionListAction: LOT_WINNERS_MANAGEMENT.ACTIONS.GET_WINNER_SELECTION_LIST,
        selectWinnersAction: LOT_WINNERS_MANAGEMENT.ACTIONS.SELECT_WINNERS,
        updateWinnersAction: LOT_WINNERS_MANAGEMENT.ACTIONS.UPDATE_WINNERS,
        clearWinnerSelectionListAction: LOT_WINNERS_MANAGEMENT.ACTIONS.CLEAR_WINNER_SELECTION_LIST
      }),
      ...mapActions(LOT_DOCUMENT_GENERATOR.NAMESPACE, {
        getLotProtocolAction: LOT_DOCUMENT_GENERATOR.ACTIONS.GET_LOT_PROTOCOL,
        attachLotProtocolAction: LOT_DOCUMENT_GENERATOR.ACTIONS.ATTACH_LOT_PROTOCOL,
        getLotOffersRegistryAction: LOT_DOCUMENT_GENERATOR.ACTIONS.GET_LOT_OFFERS_REGISTRY,
        attachLotOffersRegistryAction: LOT_DOCUMENT_GENERATOR.ACTIONS.ATTACH_LOT_OFFERS_REGISTRY
      }),
      initialize: async function () {
        this.isLoading = true
        try {
          await Promise.all([
            this.getTradeProcessDocumentationAction({
              lotId: this.lot.lotId,
              lotType: this.lot.lotType
            }),
            this.getWinnerSelectionListAction({
              lotId: this.lot.lotId,
              lotType: this.lot.lotType
            })
          ])

          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      clearStore: async function () {
        await Promise.all(
          [
            this.clearWinnerSelectionListAction(),
            this.clearTradeProcessDocumentationAction()
          ])
      },
      getLotProtocol: async function () {
        try {
          this.isLoading = true
          await this.getLotProtocolAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getLotOffersRegistry: async function () {
        try {
          this.isLoading = true
          await this.getLotOffersRegistryAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      attachLotOffersRegistry: async function () {
        try {
          this.isLoading = true
          await this.attachLotOffersRegistryAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
          await this.initialize()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      setNoPremiumOrdersResult: async function () {
        await this.setTradeResult(this.selectWinnersAction)
      },
      setFailedResult: async function () {
        await this.setTradeResult(this.updateWinnersAction)
      },
      setTradeResult: async function (methodName) {
        const model = {
          lotId: this.lot.lotId,
          lotType: this.lot.lotType,
          result: {
            tradeResultType: TRADE_RESULT_TYPES.NO_ORDERS
          }
        }
        try {
          this.isLoading = true
          await methodName(model)
          await this.getWinnerSelectionListAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      goToWinnerSelection: function () {
        this.goToRoute(`${this.urlRootPath}/lot/${this.lot.lotType}/${this.lot.lotId}/winners`)
      },
      openConfirmDialog: function () {
        this.confirmDialog.text = this.$t('После подведения итогов создание новых торговых сессий по торговой процедуре будет недоступно. Торговая процедура переместится в архив завершенных торговых процедур. Продолжить?')
        this.confirmDialog.callback = this.setNoPremiumOrdersResult
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      openConfirmForFailedResultDialog: function () {
        this.confirmDialog.text = this.$t('Итог по торговой процедуре будет изменен на "Торги не состоялись". Продолжить?')
        this.confirmDialog.callback = this.setFailedResult
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      }
    }
  }
</script>
